/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { FC, useContext, useEffect, useState } from 'react';
import styles from './descriptionPhoto.module.scss';
import { ObraProperties, WandaProject } from '../../../types/ObraDetails';
import Carousel from './carousel/carousel';
import { Description } from './description/description';
import { Documentation } from './documentation/documentation';
import { useTranslation } from 'react-i18next';
import ObrasAPI from '../../../services/APIObras';
import ErrorDetails from '../components/ErrorDetails/ErrorDetails';
import { DetailsViewContext } from '../../../context/DetailsViewProvider';
import { SaveContext } from '../../../context/SaveProvider';
import DescriptionLoadingSkeleton from './components/descriptionLoadingSkeleton/descriptionLoadingSkeleton';


// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface DescriptionPhoto {
  obra: ObraProperties;
  codCentro: string;
  wandaProject?: WandaProject;
  wandaProjectLoading: boolean;
  wandaProjectError: boolean;
  version: 'viewer' | 'editor';
  errors?: Array<{ field?: string }>;
}

const DescriptionPhoto: FC<DescriptionPhoto> = (props) => {
  const {
    obra,
    codCentro,
    wandaProject,
    wandaProjectLoading,
    wandaProjectError,
    version,
    errors,
  } = props;
  const { t, i18n } = useTranslation();
  const {
    setObra,
    loadedDetailSections,
    markDetailSectionLoaded,
  } = useContext(DetailsViewContext);
  const saveContext = useContext(SaveContext);
  const [descriptionLoaded, setDescriptionLoaded] = useState(false);
  const [loadError, setLoadError] = useState(false);
  const sectionKey = `${codCentro}:${version}:${i18n.language}:description`;

  useEffect(() => {
    let active = true;
    setLoadError(false);

    if (loadedDetailSections[sectionKey]) {
      setDescriptionLoaded(true);
      return () => {
        active = false;
      };
    }

    setDescriptionLoaded(false);

    if (!wandaProject) return () => {
      active = false;
    };

    ObrasAPI.getInstance().getObraDescriptionAPI(codCentro, wandaProject, version)
      .then((response) => {
        if (!active) return;
        setObra({
          ...obra,
          descripcion: response.descripcion,
        });
        markDetailSectionLoaded(sectionKey);
        setDescriptionLoaded(true);
      })
      .catch(() => {
        if (active) setLoadError(true);
      });

    return () => {
      active = false;
    };
  }, [codCentro, loadedDetailSections, markDetailSectionLoaded, sectionKey, wandaProject, version, i18n.language, saveContext.reloadData]);

  if (loadError || wandaProjectError) return <ErrorDetails />;
  if (!descriptionLoaded || wandaProjectLoading) return <DescriptionLoadingSkeleton />;

  return (<div className={styles.descriptionPhotoContainer} data-testid="descriptionPhoto-test">
    <div>
      <Description data={obra.descripcion} errors={errors}/>
      <Carousel data={obra.descripcion.fotos} codCentro={codCentro} error={errors && errors.filter((e) => e.field === 'fotos').length > 0 ? t('details.validationError.photo') : null}/>
      <Documentation data={obra.descripcion} error={errors && errors.filter((e) => e.field === 'documentacionProyecto').length > 0 ? t('details.validationError.document') : null}/>
      <div className='footer' style={{marginBottom: '75px'}}></div>
    </div>
  </div>);
};

export default DescriptionPhoto;
